// extracted by mini-css-extract-plugin
export var completionBody = "_e6-2";
export var completionCard = "_e6-0";
export var completionFooter = "_e6-3";
export var completionTitle = "_e6-1";